import { useEffect, useRef } from "react";
import LoadingSpinner from "../components/LoadingSpinner";

const SignoutRedirect: React.FC = () => {
    const getRedirectUrl = () => {
        const dealershipUrl = localStorage.getItem("dealershipUrl");
        let url = `${import.meta.env.VITE_SITE_BASE}`;
        if (dealershipUrl) {
            url = `${import.meta.env.VITE_DCP_WEB_APP_BASE_URL}`;
            if (url.endsWith("/")) {
                url += dealershipUrl;
            } else {
                url += `/${dealershipUrl}`;
            }
        }
        return url;
    };

    const redirUrlString = useRef<string>(getRedirectUrl());

    useEffect(() => {
        window.location.replace(redirUrlString.current);
    }, [redirUrlString]);

    return (
        <>
            <LoadingSpinner />
            <noscript>
                <a href={redirUrlString.current}>Continue</a>
            </noscript>
            <div style={{ textAlign: "center", marginTop: 24 }}>
                <a href={redirUrlString.current}>
                    If you are not redirected, tap here.
                </a>
            </div>
        </>
    );
};

export default SignoutRedirect;
